import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { CoachTrainingSessionTplDelete } from "./training-tpl-delete";
import { CoachTrainingSessionTplNew } from "./training-tpl-new";
import { CoachTrainingSessionTplEdit } from "./training-tpl-edit";
import { useNavigate } from "react-router-dom";
import { TrainingSessionPhaseTpl, TrainingSessionTpl } from "../../../../interfaces/training-session-tpl";
import { cloneTrainingSessionTpl, getTrainingSessionTpl } from "../../../../services/training-session-tpl";

export function CoachTrainingTplList() {
    const navigate = useNavigate();

    const [trainingSessionTpl, setTrainingSessionTpl] = useState<TrainingSessionTpl[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    useEffect(() => {
        getTrainingSessionTpl()
            .then((response: any) => {
                setTrainingSessionTpl(response.data);
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;

        /*getTrainingSessionTpl(s, club)
            .then(response => {
                setTrainingSessionTpl(response.data);
            })
            .catch(error => {
                console.log(error);
            });*/
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: TrainingSessionTpl) => {
        const newTrainingSessionTpl = [
            s,
            ...trainingSessionTpl
        ];
        setTrainingSessionTpl(newTrainingSessionTpl);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newTrainingSessionTpl = trainingSessionTpl.filter((m: TrainingSessionTpl) => m.id != id);
        setTrainingSessionTpl(newTrainingSessionTpl);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedTrainingSessionTpl: TrainingSessionTpl) => {
        setSelectedId(0);
        const newTrainingSessionTpl = trainingSessionTpl.map((m: TrainingSessionTpl) => {
            if (m.id == changedTrainingSessionTpl.id) {
                return changedTrainingSessionTpl;
            } else {
                return m;
            }
        });
        setTrainingSessionTpl(newTrainingSessionTpl);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handlePhases = (event: any) => {
        event.preventDefault();
        navigate('/coach/training-session-tpls/' + event.currentTarget.dataset.id +  '/phases')
    }

    const handleClone = (event: any) => {
        event.preventDefault();
        const body = {
            id: event.currentTarget.dataset.id
        }
        cloneTrainingSessionTpl(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    setTrainingSessionTpl([
                        response.data.data,
                        ...trainingSessionTpl
                    ]);
                } else {
                    alert(response.data.message);
                }
            });
    }

    return (
        <div className="training-session-tpls-list-container">
            <h1>
                { t('training_session_tpls')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { trainingSessionTpl.map((s: TrainingSessionTpl) => {
                        const numPhases = s.phases.length;
                        const numExercises = s.phases.reduce((previousValue, currentValue: TrainingSessionPhaseTpl) => {
                            return previousValue + currentValue.exercises.length
                         } , 0);
                        return <Col key={ 'training-session-tpl-' + s.id } xs={12} md={6} lg={4} xl={3}>
                            <div className="training-session-tpl-card">
                                <div className="inner">
                                    <div className="name">
                                        { s.name }
                                    </div>
                                    <div className="meta">
                                        <div className="counter">
                                            { (numPhases == 0) && t("no_phases_message") } 
                                            { (numPhases == 1) && <span>{ t("one_phase") }</span> } 
                                            { (numPhases > 1) && <span>{ numPhases } { t("multiple_phases") }</span> }   
                                        </div>
                                        <div className="exercises">
                                            { (numExercises == 0) && t("no_exercises_message") } 
                                            { (numExercises == 1) && <span>{ t("one_exercise") }</span> } 
                                            { (numExercises > 1) && <span>{ numExercises } { t("multiple_exercises") }</span> }   
                                        </div>
                                    </div>
                                </div>
                                <div className="actions">
                                    <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ s.id }>
                                        <i className="bi bi-pencil-square"></i>
                                    </a>
                                    <a href="#" className="icon-link phases" title={ t("phases") } onClick={ handlePhases } data-id={ s.id }>
                                        <i className="bi bi-sliders2-vertical"></i>
                                    </a>
                                    <a href="#" className="icon-link clone" title={ t("clone") } onClick={ handleClone } data-id={ s.id }>
                                        <i className="bi bi-copy"></i>
                                    </a>
                                    <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ s.id }>
                                        <i className="bi bi-trash"></i>
                                    </a>
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
            </div>   
            {<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>}
            { showAddNew &&
                <CoachTrainingSessionTplNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <CoachTrainingSessionTplEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <CoachTrainingSessionTplDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
        </div>

    )
}
